import React, {useEffect} from "react";
import {useFieldArray} from "react-hook-form";
import TextInput from "../../Components/Inputs/TextInput";
import AddItemButton from "../../Components/Buttons/AddItemButton";
import SingleCheckbox from "../../Components/Inputs/SingleCheckbox";
import axios from "axios";
import ReactSelectAsync from "../../Components/Inputs/ReactSelectAsync";

export default function ({control, errors, register, watch, data, setData}) {
  const {fields, append, remove} = useFieldArray({
    control,
    name: "products",
    keyName: "index",
  });

  useEffect(() => {
    if(watch('products')){
      let productIds = watch('products').map((item) => {
        return item.product_id
      })
      searchProducts(productIds, null, true)
    }
  }, [JSON.stringify(watch(['categories', 'only_discounted', 'products']))])

  const searchProducts = (productIds, keyword, updateProducts = false) => {
    return axios.get('sliders/search-products',
      {
        params: {
          product_ids: productIds.filter(Number),
          categories: watch('categories'),
          only_discounted: watch('only_discounted') ? 1 : 0,
          keyword: keyword
        }
      }).then(res => {
      if (res.data.status === 'success') {
        if (updateProducts){
          setData({...data, products: res.data.products})
        }
        return filterProducts(null, res.data.products);
      }
    });
  }

  const filterProducts = (selectedProductId, products) => {
    return products.filter(item => {
      let selectedProductIds = watch('products').map((item) => {
        if (selectedProductId !== item.product_id) {
          return item.product_id
        }
      })

      return (item.id !== selectedProductIds.find(id => item.id === id))
    });
  }

  return (
    <div className="card card-flush py-4 mt-3">
      <div className="card-header">
        <div className="card-title">
          <h2>Products</h2>
        </div>
        {errors?.products && (
          <div className="fv-plugins-message-container invalid-feedback mb-5">
            <div>{errors.products}</div>
          </div>
        )}
      </div>

      <div className="card-body pt-0">
        <div className="fv-row">
          <div className='w-50 pb-3'>
            <SingleCheckbox
              name="only_discounted"
              register={register}
              label="Show only sales"
            />
          </div>

          {fields.map((item, index) => {
            return <div key={item.index} className="d-flex gap-3">
              <div className='w-50'>
                <ReactSelectAsync
                  label="Product"
                  name={`products.${index}.product_id`}
                  placeholder="Choose Products"
                  options={filterProducts(watch(`products.${index}.product_id`), data.products)}
                  errorMessage={errors?.[`products.${index}.product_id`]}
                  control={control}
                  search={(val) => searchProducts([watch(`products.${index}.product_id`)], val)}
                />
              </div>

              <div className='w-50'>
                <TextInput
                  label='Position'
                  name={`products.${index}.position`}
                  register={register}
                  errorMessage={errors?.[`products.${index}.position`]}
                />
              </div>

              <button
                type="button"
                onClick={() => remove(index)}
                className="btn btn-danger btn-hover-scale btn-size"
              >
                -
              </button>
            </div>
          })}

          <AddItemButton title='Add' onClick={() => append({
            product_id: null, position: null,
          })}/>
        </div>
      </div>
    </div>
  );
}